import { useSelector } from "react-redux";
import { Outlet, ScrollRestoration } from "react-router-dom";
import PublicFooterV2 from "../../components/ui/PublicFooterV2";
import { Fragment } from "react";
import ClosingPage from "../../components/common/Closing";
import { getLanguageContent } from "../language/languageSelector";
import { PUBLIC_FOOTER_SCHEMA } from "../schemas/language/components/publicfooterSchema";

const PublicLayout = () => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const content = getLanguageContent(PUBLIC_FOOTER_SCHEMA).closing_page;

  // While auth is resolving, we usually don't want to flash the footer
  if (isLoading) return null;

  return (
    <>
      <ScrollRestoration />

      {/* If guest: wrap in <main className="public"> for marketing styles.
          If logged in: just render the content so it fits your app dashboard.
      */}
      {!isAuthenticated ? (
        <Fragment>
          <main className="public">
            <Outlet />
            <ClosingPage
              title={content.heading}
              description={content.description}
              imageAlt={content.image_alt}
              image="network_map_svg.svg"
              ctas={content.ctas}
              containerClasses="padding-full"
            />
          </main>
          <PublicFooterV2 />
          <script src="main.js"></script>
        </Fragment>
      ) : (
        <main className="public">
          <Outlet />
        </main>
      )}
    </>
  );
};

export default PublicLayout;
